import * as React from 'react';
import Box from '@mui/material/Box';
import { observer } from 'mobx-react';
import { TableJobsOverview } from './TableJobsOverview';
import { getRandomKey } from '../helpers/base';
import { Typography } from '@mui/material';
import { toJS } from 'mobx';
import SearchOutputCollapse from '../pages/client/main/parts/search/components/SearchOutputCollapse';

interface OutputProps {
  data?: any;
}

const Output = observer(({ data }: OutputProps) => {
  if (!data?.response?.response) {
    return null;
  }

  const renderHtmlType = (data: any) => {
    const content = [];
    if (data.response.showType === 'search') {
      data.response.response.forEach((dataset: any) => {
        Object.keys(dataset).forEach((key) => {
          const items = dataset[key];
          if (items.length > 0) {
            content.push(
              <div key={getRandomKey()} style={{ marginBottom: '10px' }}>
                <TableJobsOverview
                  data={items}
                  key={getRandomKey()}
                  title={key}
                  showDownloadCsvButton={data?.request === 'Metrics launch'}
                />
              </div>
            );
          }
        });
      });
    } else {
      content.push(
        <TableJobsOverview
          data={data.response.response}
          showDownloadCsvButton={data?.request === 'Metrics launch'}
        />
      );
    }

    return (
      <div
        style={{
          marginBottom: '15px',
          padding: '10px',
          backgroundColor: 'rgba(0, 0, 0, 0.06)',
          minHeight: '180px',
          overflow: 'scroll',
        }}
      >
        {content}
      </div>
    );
  };

  const showTypeOutput = () => {
    const dataJS = toJS(data);

    if (!data?.response?.response) {
      return <Typography color='text.secondary'>Nothing to show</Typography>;
    }

    switch (data.type) {
      case 'html':
        return data.type === 'html' && data.response.response
          ? renderHtmlType(data)
          : '';
      case 'tree':
        if (!dataJS) {
          return '';
        }
        return <SearchOutputCollapse data={dataJS.response.response} />;
      default:
        return <Typography color='text.secondary'>Nothing to show</Typography>;
    }
  };

  return (
    <>
      <h2 style={{ borderBottom: '1px solid #ccc', paddingBottom: '8px' }}>
        Output {data.request ? `- ${data.request}` : null}
      </h2>
      <Box>{showTypeOutput()}</Box>
    </>
  );
});

export default Output;
